import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class ImageShape extends BaseOption {
  static userInterfaceComponent = {
    label: "Image Shape",
    component: inspectorTools.RADIO_BAR,
    props: {
      iconSize: 24,
      options: [
        {
          icon: "square",
          value: "rectangle",
        },
        {
          icon: "circle",
          value: "circle",
        },
      ],
    },
  };

  static defaultValue = "rectangle";
}
